import { Chip, ColourVariant, IconVariant } from '@weareopenr/component-library';

type EntityKey = 'price-scheme' | 'option-group' | 'scheduled-publish' | 'menus' | 'publish' | 'menu-set';
type StatusMap = Record<string, { colour: ColourVariant; icon?: IconVariant; label?: string }>;

const priceSchemeStatusMap: StatusMap = {
  IN_USE: { colour: 'kale', icon: 'tick', label: 'In Use' },
  SCHEDULED: { colour: 'honey', icon: 'scheduled', label: 'Scheduled' },
  NOT_IN_USE: { colour: 'blueberry', icon: 'pause', label: 'Not In Use' },
};

const optionGroupStatusMap: StatusMap = {
  Bundle: { colour: 'grape' },
  Standard: { colour: 'blueberry' },
  'Non-food': { colour: 'honey' },
  Modifier: { colour: 'kale' },
};

const scheduledPublishStatusMap: StatusMap = {
  NOT_VALIDATED: { colour: 'blueberry', label: 'Unvalidated' },
  VALIDATING: { colour: 'honey', label: 'Validating', icon: 'scheduled' },
  VALIDATED: { colour: 'kale', label: 'Validated', icon: 'tick' },
  VALIDATION_FAILED: { colour: 'tomato', label: 'Validation Failed', icon: 'x' },
};

const publishStatusMap: StatusMap = {
  SUCCESS: { colour: 'kale', label: 'Success', icon: 'tick' },
  FAILURE: { colour: 'tomato', label: 'Failure', icon: 'x' },
  PENDING: { colour: 'honey', label: 'In Progress', icon: 'scheduled' },
  PARTIAL_SUCCESS: { colour: 'honey', label: 'Partial Success', icon: 'scheduled' },
  SENT: { colour: 'honey', label: 'Sent', icon: 'scheduled' },
  REJECTED: { colour: 'tomato', label: 'Rejected', icon: 'x' },
};

const menuStatusMap: StatusMap = {
  LIVE: { colour: 'kale', label: 'Live', icon: 'tick' },
  NOT_LIVE: { colour: 'blueberry', label: 'Not Live', icon: 'pause' },
};

const menuSetStatusMap: StatusMap = {
  VIEW_ONLY: { colour: 'blueberry', label: 'View Only', icon: 'view' },
};

const statusMaps: Record<EntityKey, StatusMap> = {
  'price-scheme': priceSchemeStatusMap,
  'option-group': optionGroupStatusMap,
  'scheduled-publish': scheduledPublishStatusMap,
  publish: publishStatusMap,
  menus: menuStatusMap,
  'menu-set': menuSetStatusMap,
};

type StatusChipProps = { entity: EntityKey; status: string; label?: string };

export const StatusChip = ({ entity, status, label }: StatusChipProps) => {
  const map = statusMaps[entity];
  const chipProps = map?.[status] ?? { colour: 'blueberry' };

  return <Chip label={label ?? chipProps.label ?? status} backgroundColour={chipProps.colour} icon={chipProps.icon} />;
};
